

<div *ngIf="dashboard || posts.length>0 || !dashboard" class=" relative " (scroll)="infinitScroll($event)">
	<div class=" flex flex-col justify-between w-full"
	[ngClass]="{
			'overflow-hidden h-full ':dashboard,
			'overflow-auto  mx-auto h-[85vh]':!dashboard,
		}"
	>
	<!-- 'h-[85vh] ': !dashboard,
	'h-full': dashboard, -->
	<div *ngIf="false && userHasPermission('publication.get.:id') && (!dashboardSource || dashboardSource == 'facebook' || dashboardSource == 'instagram')" class="flex justify-center gap-2  text-sm m-0 p-1">
		<div
		*ngIf="(!dashboardSource || dashboardSource == 'facebook')"
		class="p-2 bg-facebook text-white rounded-full  flex gap-1"
		(click)="fetchPosts('facebook')"
		[ngClass]="{
					'cursor-not-allowed': isFetchingForFacebookPosts,
					'cursor-pointer': !isFetchingForFacebookPosts
				}"
			>
			<div>
				<span [ngClass]="{'cursor-not-allowed loading loading-spinner': isFetchingForFacebookPosts}"></span>
			</div>
			{{"pages.fetchFacebookPosts" | translate}}
		</div>
		<div
		*ngIf="(!dashboardSource || dashboardSource == 'instagram')"
		class="p-2 bg-pink-600 text-white rounded-full flex gap-1"
		(click)="fetchPosts('instagram')"
		[ngClass]="{
					'cursor-not-allowed': isFetchingForInstagramPosts,
					'cursor-pointer': !isFetchingForInstagramPosts
				}"
			>
			<div>
				<span [ngClass]="{'loading loading-spinner': isFetchingForInstagramPosts}"></span>
			</div>
			{{"pages.fetchInstagramPosts" | translate}}
		</div>
	</div>

		<!-- filters -->
		<div class="z-40 pb-3  bg-indigo-100" [ngClass]="{'px-4': !dashboard,'bg-white': dashboard}">
			<app-post-filters [dashboard]="dashboard" [isRouteOnDashboard]="isRouteOnDashboard()"  [dashboardSource]="dashboardSource || ''"/>
		</div>
		<!-- loading PostsMsg -->
		<div *ngIf="dashboard && posts.length==0 && isLoading" class=" justify-center items-center text-center ">
			<div class="text-gray-700 text-lg p-8 ">
				{{loadingMessage | translate}}
			</div>
		</div>

	<!-- cards grid -->
	<div #postContainer
	class="flex-1 overflow-auto pb-28 pt-2 pl-4 pr-5 "
	(scroll)="infinitScroll($event)"
	[ngClass]="{'bg-[#fafafa]':isRouteOnDashboard()}"
	>
		<div class="relative pb-5">
			<div class="grid mb-3 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-5" [ngClass]="{'h-[45vh]':isRouteOnDashboard()}">
					<div *ngIf="posts.length==0 && !isLoading" class=" col-span-4 text-center text-gray-700  mt-10">
						<img src="assets/img/noresults.png" alt="No posts" class="mx-auto mb-10 w-48 h-48 "/>
						<div *ngIf="noPostsMsg=='noPosts'  " class="flex flex-col gap-2" >
							<div class="font-semibold">{{"posts.noPostsInLibraryfilter" | translate}}</div>
							<span class="font-normal text-sm">{{"posts.noPostsInLibraryfilterDetails" | translate}}</span>
							<a class="text-sm underline text-cliking_blue cursor-pointer" (click)="resetFilters()">
								<span class="flex items-center justify-center gap-1">
									<span>
										{{"posts.clearFilters" | translate}}
									</span>
									<svg  width="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>
								</span>
							</a>
						</div>
						<div *ngIf="noPostsMsg=='noPagesOrNoPostsOnPages' " class="flex flex-col items-center gap-2">
							<div class="font-semibold">{{"posts.noPostsInLibraryData" | translate}}</div>
							<span class="font-normal text-sm" style="width: 470px;">{{"posts.noPostsInLibraryDataDetails" | translate}}</span>
							<button class="text-white font-semibold text-sm bg-cliking_blue rounded-xl p-3 m-3 mt-9" (click)="openPostFactory()">
								{{"generic.CreateAPost" | translate}}
								<span class="ml-2"><i class="fa fa-plus-circle" aria-hidden="true"></i></span>
							</button>
						</div>
					</div>
					<ng-container *ngFor="let post of posts; index as i"  >
						<div *ngIf="checkVisibility(post)" [ngClass]="{'z-50': post.isNew, }">
							<app-post-preview
								[user]="user"
								[index]="i"
								[displayAs]="displayAs(post)"
								[postIndex]="i"
								[post]="post"
								[isRootOnDashboard]="isRouteOnDashboard()"
								[dashboardSource]="dashboardPlatform()"
								(onDeleteClicked)="openDeleteModal(post, $event)"
								(onDuplicatePost)="handleDuplicatePost($event)"
								(removePostFromLibrary)="removePost($event)"
								(postUpdated)="refreshPost($event)"
								[isDeletionInProgress]="isDeletionInProgress(post.id)"
								[dashboard]="dashboard"
								/>
							</div>
					</ng-container>
			</div>
		</div>
	</div>

	<app-modal
		[isOpen]="confirmDeleteModalVisible"
		[icon]="modalIcon"
		[heading]="modalHeading"
		[subHeading]="modalSubHeading"
		[isEdit]="modalIsEdit"
    [isDeleteDisabled]="isDeleteDisabled"
		[displayAs]="postService.displayAs(currentPost)"
		[socialMediaInfos]="postService.extractSocialMediaInfo(currentPost)"
		(closeModal)="confirmDeleteModalVisible=false"
		(deleteItem)="confirmPostRemoval($event)"
	></app-modal>

	<app-loader [isLoading]="isLoading"/>

</div>
